'use es6';

export function mergeObjects(a, b) {
  if (a && !b) {
    return a;
  }
  if (!a && b) {
    return b;
  }
  if (a || b) {
    return Object.assign({}, a, b);
  }
  return undefined;
}